import { combineEpics } from 'redux-observable';
import { of } from 'rxjs';
import * as ReduxObservablesEpicUtils from '@ane/core/lib/utils/ReduxObservablesEpicUtils';
import { produceUserContextRouteQueryStringEpics } from '@ane/core/lib/services/syncUrlAndStore/ProduceUserContextRouteQueryStringEpics';
import { dataSourceListActionTypes, dataSourceListLoadingAction, dataSourceListLoadedAction, } from '../ducks';
import { getAsyncRequestStatus } from '@ane/core/lib/models';
import DataSourceResource from '../../../DataSource.resource';
import { DataSourceListUserContextParam } from '../../../../models/DataSourceListUserContextParams';
import { DataSourceListConstants, setUserContextFunc } from '../ducks/DataSourceListFilter.ducks';
import { matchesRootPathname } from '@ane/exp-data/lib/routes/Route.utils';
import { EXP_QUERY_STRINGS } from '@ane/core/lib/constants/QueryString.constants';
import { DataSourceRouteUtils } from '@ane/exp-data/lib/routes/DataSourceRoute.utils';
const loadDataSourceListArgs = {
    filterOnType: dataSourceListActionTypes.LOAD,
    loadResource: (payload, state) => {
        return DataSourceResource.getDataSourceList(payload.workspaceId, payload.search, payload.dataSourceType);
    },
    loadingAction: dataSourceListLoadingAction,
    loadedAction: (successData, payload, error) => {
        const result = {
            status: getAsyncRequestStatus(error || ''),
            data: successData,
            error: error,
        };
        return of(dataSourceListLoadedAction(payload, result));
    },
};
export const loadDataSourceEpic = ReduxObservablesEpicUtils.produceLoadLoadingLoadedEpic(loadDataSourceListArgs);
export const provideDataSourceListEpics = (history) => {
    // Adding this epic fully connects the Route URL and the Store for the given "UserContextSpec"
    // When the URL is set, the spec will be used to call the correct actions
    // When the user context is set the URL will be updated.
    const setUserContextFromRouteQueryString = produceUserContextRouteQueryStringEpics(DataSourceListUserContextParam, setUserContextFunc, DataSourceListConstants.SET_PARTIAL_USER_CONTEXT, DataSourceListConstants.SET_USER_CONTEXT, (store) => store.dataSourceManagementModule.dataSourceListState.userContext, history, (pathname) => {
        return (!matchesRootPathname(pathname, DataSourceRouteUtils.routes.view.path()) &&
            matchesRootPathname(pathname, DataSourceRouteUtils.routes.list.path()));
    }, EXP_QUERY_STRINGS);
    const dataSourceListEpics = combineEpics(loadDataSourceEpic, ...Object.values(setUserContextFromRouteQueryString));
    return dataSourceListEpics;
};

//# sourceMappingURL=DataSourceListEpic.js.map
